import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'

export interface IAdditionalAttributeOption {
  key: string;
  label: string;
  translations?: Record<string, string> | null;
  sort_order?: number;
}

export interface IAdditionalAttribute {
  id: number;
  entity_type: string;
  label: string;
  translations?: Record<string, string> | null;
  type: string;
  options: IAdditionalAttributeOption[];
  is_required: boolean;
  sort_order: number;
}

export class AdditionalAttributeApiService extends ApiService {
  static async getAll(entityType?: string): Promise<{ data: IAdditionalAttribute[] }> {
    return this.axios.get('additional-attributes', {
      params: entityType ? { entity_type: entityType } : {}
    }).then((response: AxiosResponse<{ data: IAdditionalAttribute[] }>) => response.data)
  }

  static async addOption(attributeId: number, label: string): Promise<IAdditionalAttributeOption> {
    return this.axios.post(`additional-attributes/${attributeId}/options`, { label })
      .then((response: AxiosResponse<IAdditionalAttributeOption>) => response.data)
  }
}
